import { render } from "./FormDefault.vue?vue&type=template&id=5d65cbef&scoped=true"
import script from "./FormDefault.vue?vue&type=script&lang=js"
export * from "./FormDefault.vue?vue&type=script&lang=js"

import "./FormDefault.vue?vue&type=style&index=0&id=5d65cbef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d65cbef"]])

export default __exports__